/* eslint-disable no-unsafe-optional-chaining */
import React, { useContext } from 'react';
import { Formik } from 'formik';
import { toast } from 'react-toastify';
import { bannerValidationSchema } from 'pages/ApplicationUI/constant';
import { ADD_EDIT_CONSTANT } from 'utils/constants';
import ErrorBoundary from 'components/common/ErrorBoundary';
import { axiosPost, axiosUpdate } from 'services';
import { authContext } from 'contexts/AuthContext';
import AddEditUploadPromoImageForm from './components/AddEditUploadPromoImageForm';

const getInitialValues = (type, row) => {
  const initialValues = {
    promotionType: '',
    imageUrl: '',
    redirectUrl: '',
  };

  if (type === ADD_EDIT_CONSTANT.EDIT) {
    return {
      id: row?.id,
      promotionType: row?.promotionType
        ? {
            id: row?.promotionType,
            label: row?.promotionType,
          }
        : '',
      imageUrl: row?.imageUrl || '',
      redirectUrl: row?.webImageUrl || '',
    };
  }

  return {
    ...initialValues,
  };
};

const AddEditUploadPromoImage = ({ drawerToggle, type, row, refetch }) => {
  const { auth } = useContext(authContext);

  const handleSubmit = async (values) => {
    const { imageUrl, promotionType, redirectUrl } = values;
    try {
      if (type === ADD_EDIT_CONSTANT.EDIT) {
        const resp = await axiosUpdate(
          `${process.env.REACT_APP_REST_API_ENDPOINT}banner-position/${values?.id}`,
          {
            imageUrl,
            webImageUrl: redirectUrl || '',
          },
          auth?.data?.token,
        );
        if (resp?.status === 'success') {
          toast.success('Banner updated successfully');
          refetch?.();
          drawerToggle();
        } else {
          toast.error(resp?.message || 'Unable to update banner');
        }
        return;
      }

      const resp = await axiosPost(
        `${process.env.REACT_APP_REST_API_ENDPOINT}banner-position`,
        {
          promotionType: promotionType?.id,
          imageUrl,
          webImageUrl: redirectUrl || '',
        },
        {},
        auth,
      );
      if (resp?.status === 'success') {
        toast.success('Banner created successfully');
        refetch?.();
        drawerToggle();
      } else {
        toast.error(resp?.message || 'Unable to create banner');
      }
    } catch (error) {
      toast.error('Something went wrong');
      console.error('error', error);
    }
  };

  return (
    <div>
      <ErrorBoundary>
        <Formik
          initialValues={getInitialValues(type, row)}
          enableReinitialize
          onSubmit={handleSubmit}
          validationSchema={bannerValidationSchema}
        >
          {(props) => (
            <AddEditUploadPromoImageForm
              {...props}
              type={type}
              drawerToggle={drawerToggle}
            />
          )}
        </Formik>
      </ErrorBoundary>
    </div>
  );
};

export default AddEditUploadPromoImage;
